const state = {
  washPackages: {},
  washOptions: [],
};
const getters = {
  incidentWashPackages: state => state.washPackages,
  incidentWashOptions: state => state.washOptions,
  incidentModalInputs: (state, getters, rootState, rootGetters) => {
    return {
      settings: {
        viewOnly: {
          bool: false,
          excludeFields: {}
        },
        hideFieldsOnCreate: {
          "reporter_id": true
        },
        addToRequestBody: {
          site_id: rootGetters.getHeadersSiteId,
          reporter_id: rootGetters.getHeadersSiteEmployeeId
        },
      },
      inputs: {
        incident_timestamp: {
          type: "datetime",
          label: "Date",
          required: true,
          autofillNow: true,
          classes: "flex flex-col justify-start items-start flex-auto w-full px-4 py-3"
        },
        reporter_id: {
          label: "Reported by",
          viewOnly: true,
          type: "employee",
        },
        customer_name: {
          type: "text",
          label: "Customer Name",
          required: true,
          classes: "flex-auto w-full sm:w-1/3 md:w-1/2 lg:w-1/3 px-4 py-3"
        },
        customer_phone: {
          type: "phone",
          label: "Customer Phone",
          classes: "flex-auto w-full sm:w-1/3 md:w-1/2 lg:w-1/3 px-4 py-3"
        },
        member: {
          type: "checkbox",
          label: "Member?",
          classes: "flex-auto w-full sm:w-1/3 md:w-full lg:w-1/3 px-4 py-3"
        },
        incident_type: {
          type: "dropdown",
          label: "Incident Type",
          options: [
            { id: "damage", name: "Damage" },
            { id: "rewash", name: "Rewash" },
            { id: "dispute", name: "Dispute" },
            { id: "issue", name: "Issue" }
          ],
          required: true,
          placeholder: "Select Incident Type"
        },
        damage: {
          type: "checkbox",
          label: "Damaged?",
        },
        license_plate: {
          type: "text",
          label: "License Plate",
          uppercase: true,
          maxlength: "20",
          classes: "flex-auto w-full sm:w-3/12 md:w-1/2 lg:w-3/12 px-4 py-3"
        },
        vehicle_make: {
          type: "text",
          label: "Make",
          maxlength: "30",
          classes: "flex-auto w-full sm:w-4/12 md:w-1/2 lg:w-4/12 px-4 py-3"
        },
        vehicle_model: {
          type: "text",
          label: "Model",
          maxlength: "30",
          classes: "flex-auto w-full sm:w-3/12 md:w-1/2 lg:w-3/12 px-4 py-3"
        },
        vehicle_year: {
          type: "text",
          label: "Model Year",
          placeholder: "YYYY",
          maxlength: "30",
          classes: "flex-auto w-full sm:w-2/12 md:w-1/2 lg:w-2/12 px-4 py-3"
        },
        wash_package: {
          type: "dropdown",
          label: "Wash Package",
          options: state.washOptions?.map(x => {return { id: Object.keys(x)[0], name: Object.values(x)[0]} }),
          placeholder: "Select Wash Package"
        },
        incident_cost: {
          type: "number",
          label: "Incident Cost",
          isDollar: true
        },
        receipt_number: {
          type: "text",
          label: "Invoice Number",
          maxlength: "30"
        },
        resolved: {
          type: "checkbox",
          label: "Resolved?"
        },
        incident_description: {
          type: "textarea",
          label: "Incident Description",
          required: true,
          classes: "w-full flex items-start justify-start px-4 py-3"
        },
        images: {
          type: "images"
        }
      }
    }
  }
};
const actions = {
  
};
const mutations = {
  setWashPackages(state, washArr) {
    state.washPackages = {}
    state.washOptions = []
    for (let wash of washArr) {
      const name = wash.name?.trim() || wash.description?.trim()
      if (!wash.id || !name) continue
      state.washPackages[wash.id] = name
      state.washOptions.push({ [wash.id]: name })
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};